import React, { FunctionComponent, useContext } from "react";
import { FormattedMessage } from "react-intl-phraseapp";
import { HelpDrawerWrapper } from "..";
import { AppStore } from "../../app/store";
import { sendTealiumEvent, useTranslate } from "../../helpers";
import { linkToSpap } from "../../helpers/CONSTANTS";
import { HelpDrawerWrapperProps } from "../HelpDrawerWrapper";

const CantFindDrugHelpDrawer: FunctionComponent<Partial<
  HelpDrawerWrapperProps
> & {
  tealiumProps?: {
    callingLabel: string;
    label: string;
    eventCategory?: string;
  };
  PAP?: boolean;
}> = ({ tealiumProps, PAP = false, ...props }) => {
  const t = useTranslate();
  const { state } = useContext(AppStore.AppContext);

  return (
    <HelpDrawerWrapper
      inlineToggle
      toggleText={t("drug_search.cant_find_drug")}
      drawerTitle={t("drug_search.cant_find_drug")}
      tealiumProps={tealiumProps}
      headingLevel="2"
      {...props}
    >
      <div className="ds-u-font-size--base">
        <p>{t("drug_search.cant_find.trouble_adding")}</p>
        <ul>
          <li>{t("drug_search.cant_find.check_spelling")}</li>
          {PAP ? (
            <>
              <li>{t("drug_search.cant_find.may_not_be_pap")}</li>
              <FormattedMessage
                id="drug_search.cant_find.check_for_pap"
                tagName="li"
                values={{
                  link: (
                    <a
                      href={linkToSpap(state.language)}
                      onClick={() =>
                        sendTealiumEvent(
                          "Internal Link Click",
                          "State Pharmaceutical Assistance Program",
                          { event_category: "PAP" }
                        )
                      }
                    >
                      {t("drug_search.cant_find.spap")}
                    </a>
                  ),
                }}
              />
            </>
          ) : (
            <li>{t("drug_search.cant_find.check_otc")}</li>
          )}
        </ul>
      </div>
    </HelpDrawerWrapper>
  );
};

export default CantFindDrugHelpDrawer;
